<div class="progress-bar" [style.width]="getProgressWidth()" [style.background-color]="getProgressColor()"></div>
